import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DevicesService } from '../../services/devices.service';

@Component({
  selector: 'app-undo-unit-transfer-snackbar',
  imports: [
    MatTooltipModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './undo-unit-transfer-snackbar.component.html',
  styleUrl: './undo-unit-transfer-snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UndoUnitTransferSnackbarComponent {
  public data: {
    unit_id: string;
    device_id: string;
    resetDataHandler: (() => void) | null;
    isSuccess: boolean;
  } = inject(MAT_SNACK_BAR_DATA);

  private readonly _devices = inject(DevicesService);
  private readonly _ref = inject(MatSnackBarRef<UndoUnitTransferSnackbarComponent>);

  protected undo(): void {
    this._devices.transfer(this.data.device_id, this.data.unit_id).subscribe();
    this._ref.dismiss();

    if (this.data.resetDataHandler) {
      this.data.resetDataHandler();
    }
  }
}
